import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import NotFound from './views/404.vue';
import { store } from './store.js';
import firebase from 'firebase/app';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/supporters',
			name: 'supporters',
			component: () =>
				import(/* webpackChunkName: "venue" */ './views/Supporters.vue')
		},
		{
			path: '/registration-info',
			name: 'registration-info',
			component: () =>
				import(
					/* webpackChunkName: "committee" */ './views/RegistrationView.vue'
				)
		},
		{
			path: '/committee',
			name: 'committee',
			component: () =>
				import(
					/* webpackChunkName: "committee" */ './views/Committee.vue'
				)
		},
		{
			path: '/speakers',
			name: 'speakers',
			component: () =>
				import(
					/* webpackChunkName: "speakers" */ './views/Speakers.vue'
				)
		},
		{
			path: '/create-new-user',
			name: 'create-new-user',
			component: () =>
				import(
					/* webpackChunkName: "createNewUser" */ './views/CreateNewUser.vue'
				)
		},
		{
			path: '/program',
			name: 'program',
			component: () =>
				import(
					/* webpackChunkName: "schedule" */ './views/Schedule.vue'
				)
		},
		{
			path: '/past-meetings',
			name: 'past-meetings',
			component: () =>
				import(
					/* webpackChunkName: "pastMeeting" */ './views/PastMeetings.vue'
				)
		},
		{
			path: '/housing',
			name: 'housing',
			component: () =>
				import(/* webpackChunkName: "housing" */ './views/Housing.vue')
		},
		{
			path: '/account',
			name: 'account',
			meta: {
				requiresAuth: true
			},
			component: () =>
				import(/* webpackChunkName: "account" */ './views/Account.vue')
		},
		{
			path: '/login',
			name: 'login',
			component: () =>
				import(/* webpackChunkName: "login" */ './views/Login.vue')
		},
		{
			path: '/updates',
			name: 'updates',
			component: () =>
				import(/* webpackChunkName: "updates" */ './views/Updates.vue')
		},
		{
			path: '/general',
			name: 'general',
			component: () =>
				import(
					/* webpackChunkName: "general" */ './views/GeneralInformation.vue'
				)
		},
		{
			path: '/covid-policy',
			name: 'covid-policy',
			component: () =>
				import(
					/* webpackChunkName: "covid-policy" */ './views/CovidPolicy.vue'
				)
		},
		{
			path: '/admin',
			name: 'admin',
			meta: {
				requiresAdmin: true
			},
			component: () =>
				import(/* webpackChunkName: "admin" */ './views/Admin.vue')
		},
		{
			path: '/acknowledgements',
			name: 'acknowledgements',
			component: () =>
				import(/* webpackChunkName: "acknowledgements" */ './views/Acknowledgements.vue')
		},
		{
			path: '*',
			name: 'notFound',
			component: NotFound
		}
	]
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

	if (requiresAuth) {
		let isAuthenticated = firebase.auth().currentUser;
		if (!isAuthenticated) {
			next({
				path: '/login',
				params: { nextUrl: to.fullPath }
			});
			return;
		}
	}

	if (requiresAdmin) {
		let isAuthenticated = firebase.auth().currentUser;
		let isAdmin = store.getters.user.admin;
		if (!isAuthenticated || !isAdmin) {
			return;
		}
	}
	next();
	return;
});

export default router;
